/* eslint-disable */

export function initSlider() {
	const sliders = document.querySelectorAll(".wpcore-slider");

	sliders.forEach((slider) => {
		const track = slider.querySelector(":scope  .wpcore-slider__track");
		const slides = track.querySelectorAll(
			":scope > div > div > .wpcore-slider__slide",
		);
		const prevBtn = slider.querySelector(":scope  .wpcore-slider__prev");
		const nextBtn = slider.querySelector(":scope  .wpcore-slider__next");
		let currentIndex = 0;

		if (!slides.length) return;

		// Hide nav buttons if there's no overflow (all slides fit in container)
		if (track.scrollWidth <= track.clientWidth) {
			if (prevBtn) prevBtn.style.display = "none";
			if (nextBtn) nextBtn.style.display = "none";
			return;
		}

		let scrolling = false;
		let scrollTimeout = null;
		const delay = 500;
		const scrollAmount = slides[0].offsetWidth + 24;

		// Navigation logic
		const handleScroll = (direction) => {
			// Ignore if already scrolling
			if (scrolling) return;

			scrolling = true;

			// Clear any pending timeout
			if (scrollTimeout) {
				clearTimeout(scrollTimeout);
			}

			// Scroll based on direction: 'next' or 'prev'
			const distance = direction === "next" ? scrollAmount : -scrollAmount;
			track.scrollBy({
				left: distance,
				behavior: "smooth",
			});

			// Reset scrolling flag after delay
			scrollTimeout = setTimeout(() => {
				scrolling = false;
			}, delay);
		};

		// Wheel event for trackpad/mouse scroll
		track.addEventListener("wheel", (e) => {
			e.preventDefault();

			// Only trigger if horizontal scroll is significant
			if (Math.abs(e.deltaX) > 5) {
				const direction = e.deltaX > 0 ? "next" : "prev";
				handleScroll(direction);
			}
		});

		// Next button click event
		if (nextBtn) {
			nextBtn.addEventListener("click", () => {
				handleScroll("next");
			});
		}

		// Prev button click event
		if (prevBtn) {
			prevBtn.addEventListener("click", () => {
				handleScroll("prev");
			});
		}
	});
}
